exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#add-fit .modal-dialog { \n    width: 100%;\n    max-width: 500px; \n}\n.alert-danger {\n    color: #a94442;\n    display: block;\n    /*margin: 10px 0px;*/\n    border-color: #ebcccc;\n    background-color: #f2dede;\n    padding: 15px 1px 15px 50px;\n    \n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-products/add-fits/add-fits.component.css
// module id = ../../../../../src/app/mnt-products/add-fits/add-fits.component.css
// module chunks = common